const support = (function () {
  if (!window.DOMParser) return false
  var parser = new DOMParser()
  try {
    parser.parseFromString('x', 'text/html')
  } catch (err) {
    return false
  }
  return true
})()

export default str => {
  // If DOMParser is supported, use it
  if (support) {
    var parser = new DOMParser()
    var doc = parser.parseFromString(str, 'text/html')
    return doc.body
  }

  // Otherwise, fallback to old-school method
  var dom = document.createElement('div')
  dom.innerHTML = str
  return dom
}
